const images = [
  "/gallery1.jpg",
  "/gallery2.jpg",
  "/gallery3.jpg",
  "/gallery4.jpg",
];

export default function Gallery() {
  return (
    <section className="py-20 px-6 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold mb-12 text-center text-[#2D033B]">
        Gallery
      </h2>

      <p className="text-[#5A3D73] text-center mb-12">
        Images from our outreach programs and community events.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Gallery ${index + 1}`}
            className="w-full h-48 object-cover rounded-xl shadow-md hover:scale-105 transition"
          />
        ))}
      </div>
    </section>
  );
}
